/*
 * @Author: your name
 * @Date: 2019-06-16 10:03:09
 * @LastEditTime: 2019-11-11 19:47:15
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \source\src\utility\tdtService\ReverseGeocoding\ReverseAddressService.js
 */
import AxiosConfig from "../../../config/AxiosConfigJs";
import { ReverseAddressInfo } from "./ReverseAddressInfo";



/// <summary>
/// 通过位置来解析地址
/// </summary>
export class ReverseAddressService {

	constructor() {
		this.appkey = "8a7b9aac0db21f9dd995e61a14685f05";
		this.lat = null;
		this.lon = null;
		this.tdtURL = "http://api.tianditu.gov.cn/geocoder";
		this.ver = "1";
		this.token=null;
	}


	/**
			 * 获取地址信息
			 * 如果成功会触发 ReverseAddressByLocationEvent.QueryComplete这个事件
			 * 如果失败会触发ReverseAddressByLocationEvent.QueryFault这个事件
			 */
	ReverseAddress(succeedCallback, errorCallback) {

		let postString = "{\"lon\":\"" + this.lon + "\",\"lat\":\"" + this.lat + "\",\"appkey\":\"" + this.appkey + "\",\"ver\":\"" + this.ver + "\"}";

		AxiosConfig.nationalTDTConfig
			.get(this.tdtURL, { params: { random: Math.random(), postStr: postString, type: "geocode", tk: this.token } })
			.then(function (response) {
				if (response != null) {
					let resultObj = response.data;
					let curInfo = ReverseAddressInfo.GetReverseAddressInfo(resultObj);
					if (succeedCallback) {
						succeedCallback(curInfo);
					}
				}
			})

			.catch(function (error) {
				if (errorCallback) {
					errorCallback(error.message);
				}
			});
	}

	static test()
	{	
		let service=new ReverseAddressService();
		service.lat=39.92594;
		service.lon=116.37304;
		service.ver=1;
		service.token="ebddfc3f34215c7375bddd93f03dd684";
		service.ReverseAddress(null,null);
	}

}//end ReverseAddressService

